<template>
  <div class="megatabs__panel-left">
    <nav class="fridge-navigation">
      <fridge-navigation></fridge-navigation>
      <a
        href="#"
        class="sec-link sec-1"
        :class="{ 'active': isSectionInViewport('.L_section_content__1') }"
        v-scroll-to="{
            el: '.L_section_content__1',
            duration: 200,
            easing: 'linear',
            offset: -70
        }"
      >CoolZone</a>
      <a
        href="#"
        class="sec-link sec-2"
        :class="{ 'active': isSectionInViewport('.L_section_content__2') }"
        v-scroll-to="{
            el: '.L_section_content__2',
            duration: 200,
            easing: 'linear',
            offset: -70
        }"
      >AdaptZone</a>
      <a
        href="#"
        class="sec-link sec-3"
        :class="{ 'active': isSectionInViewport('.L_section_content__3') }"
        v-scroll-to="{
          el: '.L_section_content__3',
          duration: 200,
          easing: 'linear',
          offset: -70
        }"
      >FreezeZone</a>
    </nav>
    <div style="position: relative;">
      <div
        class="L_fridge_wrapper"
        :style="`top:${fridgeOffsetTop}px; left:${fridgeOffsetLeft}px;`"
      >
        <div class="L_fridge">
          <div
            class="sec-1-zone"
            :class="{ 'sec-1-zone--visible': isSectionInViewport('.L_section_content__1')}"
          >
            <img
              src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone.png"
              class="sec-1-zone--- sec-1-zone-img-1"
              :class="{ 'sec-1-zone--visible---': isSectionInViewport('.L_section_content__1')}"
            />
            <img
              src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone-2.png"
              class="sec-1-zone--- sec-1-zone-img-2"
              :class="{ 'sec-1-zone--visible---': isSectionInViewport('.L_section_content__1')}"
            />
          </div>
          <img
            src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/adaptzone.png"
            class="sec-2-zone"
            :class="{ 'sec-2-zone--visible': isSectionInViewport('.L_section_content__2')}"
          />
          <img
            src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/freezezone.png"
            class="sec-3-zone"
            :class="{ 'sec-3-zone--visible': isSectionInViewport('.L_section_content__3')}"
          />
        </div>
      </div>

      <div ref="leftpanel_parallax">
        <!--  -->
        <div id="coolzone" class="section_wrapper-fwidth">
          <section class="L_section_wrapper">
            <div class="L_section_content L_section_content__1" ref="section_wrapper_ref">
              <!--  -->
              <div class="function-box-main">
                <span class="function-box__titleabove">CoolManagement System</span>
                <span class="function-box__name">CoolZone</span>
                <span class="function-box__subtitle">
                  {{ pl ? 'Komora chłodziarki' : 'Fridge compartment' }}
                </span>
                <p>
                  {{
                    pl
                    ? 'Znajdź najbardziej odpowiednie miejsce do przechowywania produktów spożywczych w ramach chłodziarki.'
                    : 'Find the best place for storing food products in a fridge'
                  }}
                </p>
                <a @click.prevent="onSideWidgetBtnClick(1)" href="#" class="side-widget">
                  <span class="side-widget__top">{{ pl ? 'Sprawdź' : 'Check' }}</span>
                  <span class="side-widget__bottom">{{ pl ? 'jak rozmieszczać produkty' : 'how to place products' }}</span>
                </a>
              </div>
              <div class="function-box-bordered function-box-bordered--lightblue">
                <div class="function-box-bordered__icontitle">
                  <div class="icontitle__icon">
                    <img
                      src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/ikony/coolbalance.svg"
                      alt="CoolBalance"
                    />
                  </div>
                  <div class="icontitle__name">CoolBalance</div>
                </div>
                <p>
                  {{
                    pl
                    ? 'Otwieraj i zamykaj lodówkę utrzymując stabilny poziom temperatury wewnątrz! Specjalna metalowa płytka na tylnej ścianie chłodziarki sprawia, że jest ona mniej podatna na wahania temperatury spowodowane otwieraniem drzwi. Takie rozwiązanie to nie tylko lepsza dbałość o świeżość produktów dzięki stabilnej temperaturze, ale także oszczędność energii i bez wątpienia bardzo estetyczne wykończenie wnętrza Twojej lodówki.'
                    : 'Open and close the fridge, and the temperature inside stays the same! A dedicated metal panel on the back wall inside the fridge makes the internal temperature less prone to fluctuate when the fridge doors are opened and closed. This helps keep the food fresh for longer, maintaining a stable temperature while improving energy efficiency and giving the interior a great look.'
                  }}
                </p>

                <left-side-video-handler v-if="pl" :vid_id="'kxwdBVk1Sfg'"></left-side-video-handler>
              </div>
              <!--  -->
            </div>
          </section>
        </div>
        <!--  -->
        <div id="adaptzone" class="section_wrapper-fwidth">
          <section class="L_section_wrapper">
            <div class="L_section_content L_section_content__2">
              <!--  -->
              <div class="function-box-main">
                <span class="function-box__titleabove">CoolManagement System</span>
                <span class="function-box__name">AdaptZone</span>
                <span class="function-box__subtitle">{{ pl ? 'Szuflada' : 'Drawer' }}</span>
                <p>
                  {{
                    pl
                    ? 'Przechowuj w szufladzie AdaptZone najbardziej wymagające produkty.'
                    : 'Store the most sensitive food products in the AdaptZone drawer'
                  }}
                </p>
                <a @click.prevent="onSideWidgetBtnClick(2)" href="#" class="side-widget">
                  <span class="side-widget__top">{{ pl ? 'Sprawdź' : 'Check' }}</span>
                  <span class="side-widget__bottom">{{ pl ? 'jak rozmieszczać produkty' : 'how to place products' }}</span>
                </a>
              </div>
              <div class="function-box-bordered function-box-bordered--lightgreen">
                <div class="function-box-bordered__icontitle">
                  <div class="icontitle__icon">
                    <img
                      src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/ikony/adaptzone.svg"
                      alt="AdaptZone"
                    />
                  </div>
                  <div class="icontitle__name">AdaptZone</div>
                </div>
                <p>
                  {{
                    pl
                    ? 'AdaptZone to szuflada we wnętrzu chłodziarki z możliwością odrębnej regulacji temperatury za pomocą specjalnego przycisku na panelu sterowania. Jest to idealne miejsce dla produktów, które wymagają szczególnych warunków przechowywania. Dzięki wtłoczeniu poprzez specjalny otwór odpowiedniej ilości chłodnego powietrza oraz możliwości ustawienia konkretnej temperatury w zakresie od -3 do 3°C przechowywane w szufladzie produkty dłużej zachowują swój smak, zapach i wartości odżywcze.'
                    : 'AdaptZone is a fridge drawer where the temperature can be adjusted separately from -3 to 3°C by means of a special button on the control panel. It is an ideal place for products which require special storage conditions: raw meat and fish, some fruits and vegetables , desserts and coffee grains.'
                  }}
                </p>
              </div>
              <!--  -->
            </div>
          </section>
        </div>
        <div id="freezezone" class="section_wrapper-fwidth">
          <section class="L_section_wrapper L_section_wrapper--last">
            <div class="L_section_content L_section_content__3">
              <!--  -->
              <div class="function-box-main">
                <span class="function-box__titleabove">CoolManagement System</span>
                <span class="function-box__name">FreezeZone</span>
                <span class="function-box__subtitle">{{ pl ? 'Szuflady zamrażarki' : 'Freezer drawers' }}</span>
                <p>
                  {{
                    pl
                    ? 'Znajdź optymalne miejsce na zapasy w szufladach zamrażarki.'
                    : 'Find the most suitable storage place in the freezer’s drawers.'
                  }}
                </p>
                <a @click.prevent="onSideWidgetBtnClick(3)" href="#" class="side-widget">
                  <span class="side-widget__top">{{ pl ? 'Sprawdź' : 'Check' }}</span>
                  <span class="side-widget__bottom">{{ pl ? 'jak rozmieszczać produkty' : 'how to place products' }}</span>
                </a>
              </div>
              <div class="function-box-bordered function-box-bordered--darkblue">
                <ul>
                    <li>
                      {{ pl ? 'Najlepsze efekty uzyskuje się przy obniżeniu temperatury poniżej -18&deg;C.' : 'The best results can be expected when the temperature drops below -18&deg;C.' }}
                    </li>
                    <li>
                      {{ pl ? 'Mrożenie nie zmienia struktury białek, tłuszczów, nie powoduje utraty witamin. Mrożone produkty nie tracą swoich wartości smakowych.' : 'Freezing does not affect the structure of proteins or fats,  nor does it kill vitamins. Food products do not lose their flavour in the process of freezing.' }}
                    </li>
                    <li>
                      {{ pl ? 'Poprzez zamrażanie produktów można wydłużyć okres przechowywania aż do 12 miesięcy.' : 'Frozen food products can be stored for up to 12 months.' }}
                    </li>
                    <li>
                      {{ pl ? 'Mrożenie można stosować zarówno do produktów mącznych jak i mięs, wędlin oraz ryb.' : 'Flour products, meat, cold cuts and fish can all be frozen.' }}
                    </li>
                </ul>
              </div>
              <!--  -->
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="function-wrapper">
      <div class="function-inner">
        <div class="function-left">
          <div class="function-title">
            <img
              src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/ico-total-nofrost.svg"
              alt
            />
            <h4>
              Total
              <br />NoFrost
            </h4>
          </div>
          <template v-if="pl">
            <p>
              Lubisz rozmrażać lodówkę? Jeśli nie, już nigdy nie będziesz musiał tego robić! Technologia Total NoFrost zapewnia stałą kontrolę poziomu wilgotności zarówno w chłodziarce jak i zamrażarce, co oznacza brak szronu w środku. A brak szronu to brak potrzeby rozmrażania!
            </p>
            <p>
              Total NoFrost to też większa higiena i dłuższa świeżość Twoich produktów, bo stała temperatura w całej lodówce ogranicza do minimum ryzyko rozwoju bakterii. Nie musisz nic robić, a wygodnie oszczędzasz!
            </p>
          </template>
          <p v-else>
            Who enjoys defrosting their fridge? From now on you never have to again! The Total NoFrost technology constantly monitors the humidity level in the fridge and freezer as well, ensuring no frost inside. No frost means more than no defrosting, it also provides better hygiene and longer product freshness, as the stable temperature in the entire refrigerator minimizes the risk of bacteria. No need to do anything, just save time in comfort!
          </p>
        </div>
        <div class="function-right">
          <img
            src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/lodowka-nofrost.png"
            alt
          />
        </div>
      </div>
    </div>

    <!--  -->
    <transition name="slide-fade">
      <left-side-site-one @btnBackClicked="closeSideSite()" v-if="visibleSideSiteIndex == 1"></left-side-site-one>
      <left-side-site-two @btnBackClicked="closeSideSite()" v-if="visibleSideSiteIndex == 2"></left-side-site-two>
      <left-side-site-three @btnBackClicked="closeSideSite()" v-if="visibleSideSiteIndex == 3"></left-side-site-three>
    </transition>
    <!--  -->
  </div>
</template>

<script>
import FridgeNavigation from "./FridgeNavigation";

import LeftSideSiteOne from "./LeftSideSiteOne";
import LeftSideSiteTwo from "./LeftSideSiteTwo";
import LeftSideSiteThree from "./LeftSideSiteThree";
import LeftSideVideoHandler from "./LeftSideVideoHandler";

export default {
  props: ["component_data"],
  data() {
    return {
      parallaxSectionOffsetTop: 0,
      parallaxSectionOffsetLeft: 0,
      visibleSideSiteIndex: 0
    };
  },
  computed: {
    fridgeOffsetTop() {
      return (
        this.parallaxSectionOffsetTop * 0.19 - this.parallaxSectionOffsetTop
      ); // 5.255 to współczynnik  wynikający z proporcji 411px przesunięcia pomiędzy częściami lodówki a 2160px odległości pomiędzy centrami sekcji
    },
    fridgeOffsetLeft() {
      return this.parallaxSectionOffsetLeft;
    }
  },
  mounted() {
    this.handleScroll();
  },
  methods: {
    handleScroll() {
      let leftPanelParallax = this.$refs.leftpanel_parallax;
      let sectionWrapperRef = this.$refs.section_wrapper_ref;

      if (leftPanelParallax) {
        var bounding = leftPanelParallax.getBoundingClientRect();
        if (bounding.top <= -60 && bounding.top > -3470) {
          this.parallaxSectionOffsetTop = bounding.top;
        } else if (bounding.top <= -3470) {
          this.parallaxSectionOffsetTop = -3470;
        } else {
          this.parallaxSectionOffsetTop = -60;
        }
      }

      if (sectionWrapperRef) {
        let sectionWrapperBounding = sectionWrapperRef.getBoundingClientRect();
        this.parallaxSectionOffsetLeft = sectionWrapperBounding.left;
      }
    },
    onSideWidgetBtnClick: function(section_index) {
      this.visibleSideSiteIndex = section_index;
    },
    closeSideSite: function() {
      this.visibleSideSiteIndex = 0;
    },
    inViewport(el) {
      var elH = el.clientHeight,
        H = window.innerHeight,
        r = el.getBoundingClientRect(),
        t = r.top,
        b = r.bottom;
      return Math.max(0, t > 0 ? Math.min(elH, H - t) : b < H ? b : H);
    },
    isSectionInViewport(selector) {
      let sec = document.querySelector(selector);
      if (sec) {
        return this.inViewport(sec) > 500 ? true : false;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
  },
  components: {
    FridgeNavigation,
    LeftSideSiteOne,
    LeftSideSiteTwo,
    LeftSideSiteThree,
    LeftSideVideoHandler
  }
};
</script>

<style lang="scss" scoped>
.megatabs__panel-left section:nth-child(even) {
  /* background: rgba(211, 211, 211, 0.295); */
}

.fridge-navigation {
  position: fixed;
  right: 70px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 100px;

  @media only screen and (max-width: 1320px) {
    display: none;
  }

  .sec-link {
    width: 70px;
    position: absolute;
    left: 10px;
    border: none;
    background: #e8e6e1;
    border-radius: 10px;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #625d52;

    &:active,
    &:focus,
    &:hover {
      outline: none;
      text-decoration: none;
    }

    &.sec-1 {
      top: 10px;
      height: 91px;

      &.active {
        background: #5bc4f0;
        color: #fff;
      }
    }

    &.sec-2 {
      top: 107px;
      height: 41px;

      &.active {
        background: #85de43;
        color: #fff;
      }
    }

    &.sec-3 {
      top: 163px;
      height: 61px;

      &.active {
        background: #001691;
        color: #fff;
      }
    }
  }
}

.section_wrapper-fwidth {
  width: 100%;
  position: relative;

  .side-widget {
    position: relative;
    background: #e41429;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    font-weight: 300;
    font-family: "Lato";
    padding: 10px 20px 10px 20px;
    border-radius: 10px;
    transition: all 0.1s ease-in-out;
    box-shadow: 0px 20px 30px #8a041a4d;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    align-items: center;

    &:hover {
      text-decoration: none;
      transform: scale(1.05);
    }

    // &:after {
    //   content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS45OTYiIGhlaWdodD0iMTUuODQ3IiB2aWV3Qm94PSIwIDAgMTkuOTk2IDE1Ljg0NyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmYmRiZDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xOC41OSwxMi45MTNIM2EuOTkuOTksMCwxLDEsMC0xLjk4MUgxOC41OWwtNS4zLTUuMjQ5YS45ODUuOTg1LDAsMCwxLS4zMTQtLjk4NiwxLDEsMCwwLDEsLjc0My0uNzI2LDEuMDA2LDEuMDA2LDAsMCwxLC45OTEuMzI1bDcsNi45MzNhLjk4NC45ODQsMCwwLDEsMCwxLjM4N2wtNyw2LjkzM2ExLjAwNywxLjAwNywwLDAsMS0xLjM1OC0uMDQyLjk4NC45ODQsMCwwLDEtLjA2Mi0xLjM0NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0zLjk0NSkiLz48L3N2Zz4=");
    //   position: absolute;
    //   top: 54%;
    //   right: 25px;
    //   transform: translateY(-50%);
    // }

    .side-widget__top {
      text-transform: uppercase;
      font-weight: 500;
    }

    .side-widget__bottom {
      //
    }
  }

  .L_section_wrapper {
    // height: 2160px;
    height: 1620px;
    position: relative;
    width: 100%;
    max-width: 950px;
    margin: 0 auto;

    &.L_section_wrapper--last {
      height: 1080px;
    }

    .L_section_content {
      height: 1080px;
      // background: rgba(255, 0, 0, 0.04);
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;

      &.L_section_content__1 {
        &:before {
          content: "";
          background: red;
          position: absolute;
          top: 0px;
          left: -96.5%;
          height: 100vh;
          max-height: 1080px;
          width: 100%;
          z-index: -1;
          background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/sec1-left-img.jpg");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 100% 0%;
        }
      }

      &.L_section_content__2 {
        &:before {
          content: "";
          background: red;
          position: absolute;
          top: 0px;
          left: -96.5%;
          height: 100vh;
          max-height: 1080px;
          width: 100%;
          z-index: -1;
          background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/sec2-left-img.jpg");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 100% 0%;
        }
      }

      &.L_section_content__3 {
        &:before {
          content: "";
          background: red;
          position: absolute;
          top: 0px;
          left: -96.5%;
          height: 100vh;
          max-height: 1080px;
          width: 100%;
          z-index: -1;
          background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/sec3-left-img.jpg");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 100% 0%;
        }
      }

      .function-box-main {
        display: flex;
        flex-direction: column;
        width: 380px;
        margin-bottom: 40px;

        .function-box__titleabove {
          color: #27241d;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .function-box__name {
          color: #e41429;
          font-size: 44px;
          line-height: 42px;
          font-weight: 600;
        }

        .function-box__subtitle {
          color: #e41429;
          font-size: 34px;
          line-height: 42px;
          font-weight: 400;
          margin-bottom: 20px;
        }

        p {
          color: #27241d;
          font-size: 16px;
          line-height: 23px;
          font-family: "Lato";
          font-weight: 300;
          margin-bottom: 30px;
        }
      }

      .function-box-bordered {
        display: flex;
        flex-direction: column;
        width: 420px;
        position: relative;

        border-radius: 10px;
        padding: 40px;
        margin-bottom: 10px;

        &.function-box-bordered--lightblue {
          background: #f7fdff;
          border: 2px #5bc4f0 solid;
        }

        &.function-box-bordered--lightgreen {
          background: #fafff7;
          border: 2px #85de43 solid;
        }

        &.function-box-bordered--darkblue {
          background: #f8f9ff;
          border: 2px #001691 solid;
        }

        .function-box-bordered__icontitle {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 20px;

          .icontitle__icon {
            width: 70px;
            height: 70px;
            background: #e41429;
            margin-right: 20px;
            border-radius: 7px;
            flex: 0 0 auto;
          }

          .icontitle__name {
            color: #e41429;
            font-size: 44px;
            line-height: 48px;
            font-weight: 600;
          }
        }

        p, ul li {
          color: #27241d;
          font-size: 16px;
          line-height: 23px;
          font-family: "Lato";
          font-weight: 300;
        }

        ul {
            padding-left: 0px;
            list-style: none;

            li {
                margin-bottom: 10px;
                position: relative;

                &:before {
                  content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMyMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcuMzIyIDEyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojNWJjNGYwO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTE2LjA4NywxNy4xNDFhMS4yMSwxLjIxLDAsMCwxLS4xMTYsMS42LDEuMjU5LDEuMjU5LDAsMCwxLTEuNjI2LjExNGwtNC45NzYtNC45YTEuMjExLDEuMjExLDAsMCwxLDAtMS43MTRsNC45NzYtNC45YTEuMjU5LDEuMjU5LDAsMCwxLDEuNjI2LjExNCwxLjIxLDEuMjEsMCwwLDEsLjExNiwxLjZMMTIuMDA3LDEzLjFsNC4xLDQuMDQxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuMzM2IDE5LjEpIHJvdGF0ZSgxODApIi8+PC9zdmc+");
                  position: absolute;
                  left: -20px;
                  top: 0px;
                }
            }
        }

        // .function-box-bordered__video {
        //   display: flex;
        //   flex-direction: row;
        //   align-items: center;

        //   font-family: "Lato";
        //   color: #fff;
        //   font-size: 16px;
        //   font-weight: 300;
        //   letter-spacing: 0.3px;
        //   background: #5bc4f0;
        //   width: 240px;
        //   height: 60px;
        //   border-radius: 10px;

        //   position: absolute;
        //   bottom: 0px;
        //   left: 40px;
        //   transition: all 0.1s ease-in-out;
        //   transform: translateY(50%);

        //   &:hover {
        //     background: #3caede;
        //     text-decoration: none;
        //   }

        //   &:after {
        //     content: url("data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTkuOTk2IiBoZWlnaHQ9IjE1Ljg0NyIgdmlld0JveD0iMCAwIDE5Ljk5NiAxNS44NDciPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNkNWYyZmY7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTguNTksMTIuOTEzSDNhLjk5Ljk5LDAsMSwxLDAtMS45ODFIMTguNTlsLTUuMy01LjI0OWEuOTg1Ljk4NSwwLDAsMS0uMzE0LS45ODYsMSwxLDAsMCwxLC43NDMtLjcyNiwxLjAwNiwxLjAwNiwwLDAsMSwuOTkxLjMyNWw3LDYuOTMzYS45ODQuOTg0LDAsMCwxLDAsMS4zODdsLTcsNi45MzNhMS4wMDcsMS4wMDcsMCwwLDEtMS4zNTgtLjA0Mi45ODQuOTg0LDAsMCwxLS4wNjItMS4zNDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtMy45NDUpIi8+PC9zdmc+");
        //     position: absolute;
        //     top: 54%;
        //     right: 25px;
        //     transform: translateY(-50%);
        //   }

        //   .video__thumb {
        //     height: 60px;
        //     width: 60px;
        //     margin-right: 20px;

        //     border-radius: 10px;
        //     background-position: 50% 50%;
        //     background-size: contain;
        //   }
        // }
      }
    }
  }
}

@keyframes sec1animation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone.png");
    background-position: 50% 50%;
    background-size: cover;
  }
  40% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone.png");
    background-position: 50% 50%;
    background-size: cover;
  }
  60% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone-2.png");
    background-position: 50% 50%;
    background-size: cover;
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone-2.png");
    background-position: 50% 50%;
    background-size: cover;
  }
}

.L_fridge_wrapper {
  width: 458px;
  position: absolute;

  width: 100%;
  max-width: 950px;

  .L_fridge {
    width: 458px;
    height: 1509px;
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/lodowka.png");
    background-size: contain;
    z-index: 10;

    .sec-1-zone {
      width: 410px;
      height: 627px;
      position: absolute;
      left: 24px;
      top: 78px;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      // animation: sec1animation 3s linear infinite alternate;
      background-repeat: no-repeat;

      &.sec-1-zone--visible {
        opacity: 1;

        .sec-1-zone-img-1 {
          opacity: 1;
          animation: sec1imganimate 3s linear infinite alternate;
        }
        .sec-1-zone-img-2 {
          opacity: 0;
          animation: sec1imganimate 3s linear infinite alternate-reverse;
        }
      }

      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .sec-2-zone {
      width: 410px;
      position: absolute;
      left: 24px;
      top: 713px;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;

      &.sec-2-zone--visible {
        opacity: 1;
      }
    }

    .sec-3-zone {
      width: 410px;
      position: absolute;
      left: 24px;
      top: 933px;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;

      &.sec-3-zone--visible {
        opacity: 1;
      }
    }
  }
}

@keyframes sec1imganimate {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.function-wrapper {
  width: 100%;
  padding-top: 60px;
  background: #fff;
  position: relative;
  z-index: 2;

  .function-inner {
    max-width: 1420px;
    width: calc(100vw / 12 * 9);
    margin-left: calc(100vw / 12 * 2);

    display: flex;
    flex-direction: row;

    .function-left {
      width: 35%;
      margin-right: 10%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .function-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 40px;

        img {
          margin-right: 20px;
        }

        h4 {
          font-size: 44px;
          line-height: 48px;
          color: #e41429;
          font-weight: 600;
        }
      }

      p {
        font-family: "Lato";
        font-size: 18px;
        line-height: 28px;
        color: #27241d;
        font-weight: 300;
      }
    }

    .function-right {
      width: 55%;
      display: flex;
      align-items: center;

      img {
        display: block;
        max-width: 100%;
        width: 100%;
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}
</style>